<template>
  <area-container>
    <area-nav :links="links"></area-nav>
    <area-content>
      <router-view></router-view>
    </area-content>
  </area-container>
</template>

<script>
export default {
  name: "ReceptionLayout",
  computed: {
    links() {
      return [
        {
          route: "reception.Reception",
          name: this.$tk("Common.General.Reception")
        }
      ]
    }
  }
}
</script>
